
import React from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare, HeadphonesIcon } from 'lucide-react';
import { motion } from 'framer-motion';

const SupportBanner = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/605216064', '_blank');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg"
    >
      <div className="flex items-center gap-3 mb-3">
        <HeadphonesIcon className="h-5 w-5 text-blue-600" />
        <h3 className="text-sm font-medium text-blue-800">¿Necesitas ayuda?</h3>
      </div>
      <p className="text-sm text-blue-700 mb-3">
        Si tienes problemas para acceder a tu cuenta o con el proceso de pago, 
        nuestro equipo de soporte está aquí para ayudarte.
      </p>
      <Button 
        onClick={handleWhatsAppClick}
        className="bg-[#25D366] hover:bg-[#1fb855] text-white text-sm"
        size="sm"
      >
        <MessageSquare className="mr-2 h-4 w-4" />
        Contactar por WhatsApp
      </Button>
    </motion.div>
  );
};

export default SupportBanner;
